import React from "react";
import {Card, Col, Container, Image, Row,} from "react-bootstrap";
import {TeamModel} from "../../../features/team/TeamTypes";
import {useFetchTeamResults} from "../../../features/team/teamApi";

type Props = {
    team: TeamModel
}

const TeamResults = ({team}: Props) => {
    const {data:teamResults} = useFetchTeamResults(team.id);

    console.log(teamResults);

    return (
        <Container className={'mb-5'}>
            <Card className={'ps-5 pe-5'}>
                <Row className={' text-center'}>
                    <Col md={4}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    {/*<Col xs={12} md={4} className="text-center">*/}
                                    {/*    {team?.users?.slice(0, 4).map((users) => (*/}
                                    {/*        <TeamPlayersResult key={users.id} users={users}/>*/}
                                    {/*    ))}*/}
                                    {/*</Col>*/}
                                    <Col md={4}>
                                        <Image src={team.team_car_image} style={{width: "110px"}}/>
                                    </Col>
                                    {/*<Col xs={12} md={4} className="text-center">*/}
                                    {/*    {team?.users?.slice(4, 8).map((users) => (*/}
                                    {/*        <TeamPlayersResult key={users.id} users={users}/>*/}
                                    {/*    ))}*/}
                                    {/*</Col>*/}
                                </Row>
                            </Card.Body>
                        </Card>

                    </Col>
                    {/*<Col md={4} className={'d-flex flex-column align-items-center justify-content-center'}>*/}
                    {/*    <h2>TOP48</h2>*/}
                    {/*</Col>*/}
                    {/*<Col md={4} className={'d-flex flex-column align-items-center justify-content-center'}>*/}
                    {/*    <h2>Quali</h2>*/}
                    {/*</Col>*/}
                </Row>
               {/*<TeamPoints/>*/}
            </Card>
        </Container>
    );
};

export default TeamResults;
